// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"4bbf1903","164":"0d3a4233","226":"4c366a30","246":"2bb52f6f","255":"09bfe6ea","266":"1d71bdea","355":"b9538beb","531":"37aa05a0","554":"27ed57a7","793":"76940b64","822":"b9a8968f"}[chunkId] + ".chunk.css";
};